import React, { useState, useEffect } from 'react';

const WhatsAppHelp = ({ doctorName }) => {
    const [showPopup, setShowPopup] = useState(false);
    
    const phoneNumber = "8801924810590"; // Your number
    const message = `Hello, I am  ${doctorName || 'User'}. I need help with the DrChamber app.`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    useEffect(() => {
        // 1. Wait 5 seconds before showing the popup
        const showTimer = setTimeout(() => {
            setShowPopup(true);
        }, 5000);

        // 2. Hide the popup automatically after 13 seconds (5s delay + 8s visibility)
        const hideTimer = setTimeout(() => {
            setShowPopup(false);
        }, 13000);

        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
        };
    }, []);

    return (
        <div className="fixed bottom-6 right-6 z-[60] flex flex-col items-end">
            {/* Speech Bubble */}
            {showPopup && (
                <div className="mb-3 mr-2 bg-white border border-gray-200 shadow-xl rounded-2xl p-4 max-w-[200px] animate-bounce-subtle relative">
                    <p className="text-sm text-gray-700 font-medium">
                        Hi Dr. {doctorName?.split(' ')[0] || 'there'}! 👋 Need any help?
                    </p>
                    <button 
                        onClick={() => setShowPopup(false)}
                        className="absolute -top-2 -right-2 bg-gray-100 text-gray-500 rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-gray-200"
                    >
                        ✕
                    </button>
                    {/* Triangle pointer */}
                    <div className="absolute -bottom-2 right-4 w-4 h-4 bg-white border-r border-b border-gray-200 rotate-45"></div>
                </div>
            )}

            {/* WhatsApp Button */}
            <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all transform hover:scale-110 flex items-center justify-center group"
            >
                <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
            </a>
        </div>
    );
};

export default WhatsAppHelp;